// frontend/src/pages/LearningDevelopment.js
import React from 'react';
import { BookOpen, Award, Target, Users, Calendar, TrendingUp } from 'lucide-react';
import ComingSoon from '../components/UI/ComingSoon';

const LearningDevelopment = () => {
  const upcomingFeatures = [
    {
      icon: BookOpen,
      title: 'Course Library',
      description: 'Browse available training courses and certifications'
    },
    {
      icon: Award,
      title: 'Certifications',
      description: 'Track your professional certifications and renewals'
    },
    {
      icon: Target,
      title: 'Learning Goals',
      description: 'Set and track your development objectives'
    },
    {
      icon: Users,
      title: 'Training Applications',
      description: 'Apply for company-sponsored training programmes'
    },
    {
      icon: Calendar,
      title: 'Training Schedule',
      description: 'View upcoming training sessions and workshops'
    },
    {
      icon: TrendingUp,
      title: 'Progress Tracking',
      description: 'Monitor your learning journey and achievements'
    }
  ];

  return (
    <ComingSoon
      icon={BookOpen}
      title="Learning & Development"
      description="Your professional development hub is under construction. Soon you'll be able to explore courses, apply for training, and track your learning progress."
      features={upcomingFeatures}
    />
  );
};

export default LearningDevelopment;
